import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './App.css'
import App from './App.jsx'

// Tras un despliegue, los chunks con hash de una sesión ya abierta dejan de
// existir en el servidor. Vite dispara este evento cuando un import()
// dinámico falla por eso — recargamos una sola vez para traer el build actual
// en vez de dejar la pantalla en blanco.
window.addEventListener('vite:preloadError', () => {
  const key = 'acer-reload-on-chunk-error'
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')
  window.location.reload()
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)

// Una vez el build actual cargó bien, olvidamos el flag: si en esta misma
// pestaña ocurre OTRO despliegue más tarde, debe poder recargar de nuevo.
setTimeout(() => sessionStorage.removeItem('acer-reload-on-chunk-error'), 5000)
